<div [class]="'row notification-card'" [style.display]="state().value === 'inactive' ? 'none' : ''">
    <svg-icon [src]="leftIconSource" class="icon"></svg-icon>
    <div class="text-container">
        <div class="notification-text font-body2">{{ message }}</div>
    </div>
    <button class="close-button" (click)="remove()">
        <svg-icon [src]="closeIconSource"></svg-icon>
    </button>
</div>
